import { Badge } from "react-bootstrap";
import React from "react";

export default function ApprovalBadge(props) {
  return <Badge {...props}>{props.text}</Badge>;
}
